import React, { useState } from 'react';
import SimpleDialog, { SimpleDialogProps } from '../SimpleDialog/SimpleDialog';
import { AppState } from '../../../store/state';
import { AppDispatch } from '../../../store/store';
import { connect } from 'react-redux';
import styled from 'styled-components';
import DialogContentText from '@material-ui/core/DialogContentText';
import submissionSlice from '../../../store/submission/slice';
import { Submission } from '../../../store/submission/types';
import { Checkbox } from '../../ui';
import { updatePaperStatusBulkDTO } from '../../../store/info/types';
import { useTranslation } from 'react-i18next';
import { Role } from '../../../store/conference/types';

interface Props extends SimpleDialogProps {
  submission: Submission;
  role: Role;
  updatePaperStatusBulkAction: (data: updatePaperStatusBulkDTO) => void;
}

const DeleteSubmissionDialog: React.FC<Props> = ({ submission, role, updatePaperStatusBulkAction, ...rest }) => {
  const { t, i18n } = useTranslation();

  const [checked, setChecked] = useState(false);
  return (
    <SimpleDialog
      {...rest}
      title={`${t('Withdrawn submission')} #${submission.external_id}`}
      disableOkButton={!checked}
      handleOk={() => updatePaperStatusBulkAction({ submissionIds: [submission.id], paper_status_id: 0 })}
    >
      <div>
        <StyledDialogContentText id="alert-dialog-description">
          {t('Are you sure you want to withdrawn this submission?')}
        </StyledDialogContentText>
        <Checkbox label={t('Yes, I confirm')} checked={checked} onChange={(e) => setChecked(e.target.checked)} />
      </div>
    </SimpleDialog>
  );
};

const mapStateToProps = (state: AppState) => ({});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  updatePaperStatusBulkAction: (data: updatePaperStatusBulkDTO) =>
    dispatch(submissionSlice.actions['UPDATE:PAPER-STATUS:BULK'](data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DeleteSubmissionDialog);

const StyledDialogContentText = styled(DialogContentText)`
  font-size: 0.875rem;
`;
